module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n<div class=\"page-wrap\">\n  <header></header>\n  <nav-tabs class=\"desktop-nav\"></nav-tabs>\n  <div class=\"container-fluid\">\n    <router-outlet></router-outlet>\n  </div>\n</div>\n<nav-tabs class=\"mobile-nav\"></nav-tabs>\n<p class=\"version\">{{version.version}}</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main